import { Steps } from '@/api/types/steps.enum';

// Funnel prefix per step, fixed once a step has shipped: renumbering would
// split the funnel data at the deploy date. ("05b" was the lodging upsell,
// EAUG-55a, live 2026-10-19 → 2026-10-23; its events keep that label.)
const PREFIX: Record<Steps, string> = {
  [Steps.Date]: '01',
  [Steps.Type]: '02',
  [Steps.Menu]: '03',
  [Steps.Menu2]: '04',
  [Steps.Drinks]: '05',
  [Steps.Options]: '06',
  [Steps.Info]: '07',
  [Steps.Summary]: '08',
  [Steps.SummaryMenu]: '09',
  [Steps.Confirmation]: '10',
};

/**
 * Funnel-ordered step label, e.g. "01 Date", "02 Type" … "10 Confirmation".
 *
 * Directus Insights sorts bar-chart groups alphabetically and exposes no custom
 * sort, so the funnel panel (group by `step`) would otherwise render steps in
 * alphabetical order. The prefix makes alphabetical order equal wizard order.
 * Unknown steps bucket to "99 <name>" so they sort last and never throw.
 */
export function stepLabel(step: string): string {
  const prefix = Object.prototype.hasOwnProperty.call(PREFIX, step)
    ? PREFIX[step as Steps]
    : '99';
  return `${prefix} ${step}`;
}
